import BulletedTextarea from './BulletedTextarea';

export default BulletedTextarea;
